export function resolveRouteDependencies(to, from, next) {
  const promises = [];
  to.matched.forEach((entry) => {
    if (typeof entry?.meta?.resolve === 'function') {
      promises.push(entry?.meta?.resolve(to, from, next));
    }
  });

  return Promise.all(promises);
}
